import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    pathBase: String,
    reason: String,
    context: String,
    formId: String
  }

  rewrite(event) {
    event.preventDefault();

    const form = (this.hasFormIdValue && document.getElementById(this.formIdValue)) ||
                 this.element.closest('form');
    const additionalInfoEl = form ? form.querySelector('[name="quote[additional_information]"]') : null;
    const info = additionalInfoEl ? additionalInfoEl.value : "";
    const reason = this.reasonValue;

    if (this.contextValue === 'quoflow' || this.contextValue === 'servflow' || this.contextValue === 'proflow') {
      this.declineViaForm(reason, info, this.contextValue);
      return;
    }

    const newUrl = `${this.pathBaseValue}?quote[declined_reason]=${encodeURIComponent(reason)}&quote[additional_information]=${encodeURIComponent(info)}`;

    const customEvent = new CustomEvent("decline-quote:path-ready", {
      detail: { confirmPath: newUrl },
      bubbles: true
    });
    this.element.dispatchEvent(customEvent);
  }

  async declineViaForm(reason, info, context) {
    const mainEl = document.querySelector('main[data-controller~="confirm"]');
    const confirmCtrl = this.application.getControllerForElementAndIdentifier(mainEl, 'confirm');
    if (!confirmCtrl) return;

    const confirmed = await confirmCtrl.request({
      title: 'Are you sure?',
      message: 'Decline Quote?',
      confirmButton: 'Decline',
      destructive: true
    });

    if (!confirmed) return;

    const form = document.createElement('form');
    form.method = 'post';
    form.action = this.pathBaseValue;
    form.style.display = 'none';

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    const fields = {
      authenticity_token: csrfToken,
      _method: 'patch',
      'quote[declined_reason]': reason,
      'quote[additional_information]': info,
      context: context
    };

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value || '';
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.requestSubmit();
    form.remove();
  }
}
